
import { React, useEffect } from "react";
import { Col, Row } from "reactstrap";
import ProjectTables from "../components/dashboard/ProjectTable";
import json from "../services/jsonData.json";
import { useParams } from "react-router-dom";

const SlogList = () => {
  let { id } = useParams();

  useEffect(() => {
    console.log(json)
  }, [])

  return (
    <div style={{ margin: '-9px -9px' }}>
      <Row>
        <Col lg="12" 
        style={{ paddingLeft: '5px', paddingRight: '5px' }}
        >
          <ProjectTables id={id} />
        </Col>
      </Row>
    </div>
  );
};

export default SlogList;
